import styles from '../../css/Cluster.module.css';
import styled from "styled-components";

const RangeSlider = styled.input`
width: 10px;
height: 100%;
margin-left: 5px;
accent-color: #ffffff;
-webkit-appearance: slider-vertical;
&::-webkit-slider-thumb {
  height: 15px;
  width: 20px;
  background: #fff;
}
&::-webkit-slider-runnable-track {
  cursor: pointer;
  border-radius:15px;
  background: ${(props) => props.colorStyles};
}`;

export default function ClusterList({
  color,
  state,
  handleColorChange,
  sliderValue,
  handleSliderChange,
  colorList,
  gradeTextData,
  colorStyles
}) {

  return (
    <>
      <div className={`${styles.bottomContents} ${state.toggle ? styles.contentsMove : styles.contents}`}>
        <div className={styles.clusterContainer} style={{height: 'calc('+gradeTextData.length+'*22px + 20px)'}}>
          <div>
            <ul className={styles.colorbar} id="colorStatus_20230425090511324" style={{fontFamily: 'Arial'}}>
              {
                gradeTextData.map((item, idx) => (
                  <li key={'grade_'+idx} style={{background: item.color, border: '0px solid '+item.color, height: '22px', lineHeight: '22px'}}>
                    {idx == 0 && <span style={{fontSize: '12px'}}>{item.text}</span>}
                    {idx > 0 && <span style={{fontSize: '12px'}}>{item.text}</span>}
                  </li>
                ))
              }
            </ul>
          </div>
          <div className={styles.colorBar}>
            <RangeSlider type="range"
              min={0}
              max={gradeTextData.length > 0 ? gradeTextData[0].max : 0}
              step={1}
              value={sliderValue}
              onChange={handleSliderChange}
              colorStyles={colorStyles}
            />
          </div>
        </div>
        <div className={styles.colorList}>
          <ul>
            {
              colorList.map((color, idx) => (
                <li key={idx} onClick={() => handleColorChange(color)} />
              ))
            }
          </ul>
        </div>
      </div>
    </>
  )
}  